
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 2200 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1227.17 381h-48V119h48v262zm350-214h-240c-17.64 0-32 14.36-32 32v102c0 17.64 14.36 32 32 32h240c17.64 0 32-14.36 32-32V199c0-17.64-14.36-32-32-32zm0-48c44.18 0 80 35.82 80 80v102c0 44.18-35.82 80-80 80h-240c-44.18 0-80-35.82-80-80V199c0-44.18 35.82-80 80-80h240zm-1085.66 0l-122.6 206.22a15.993 15.993 0 01-13.75 7.82h-24.2c-5.64 0-10.87-2.97-13.75-7.82L194.61 119h-55.79l146.47 246.35A32.01 32.01 0 00312.8 381h60.53a32.01 32.01 0 0027.51-15.65L547.31 119h-55.79zm601.66 107H847.9c-13.25 0-24-10.75-24-24v-11c0-13.25 10.75-24 24-24h291.62v-48H831.9c-30.93 0-56 25.07-56 56v43c0 30.93 25.07 56 56 56h245.27c13.25 0 24 10.75 24 24v11c0 13.25-10.75 24-24 24H806.2L688.27 134.65A32.01 32.01 0 00660.76 119h-60.53a32.01 32.01 0 00-27.51 15.65L426.26 381h55.79l122.59-206.22c2.89-4.85 8.11-7.82 13.76-7.82h24.19c5.65 0 10.87 2.97 13.76 7.82l117.95 198.4c2.88 4.85 8.11 7.82 13.75 7.82h305.12c30.93 0 56-25.07 56-56v-43c0-30.93-25.07-56-56-56zm920-107v214.65h-14.42c-9.06 0-17.25-3.73-23.08-9.73l-166.66-179.06c-14.64-15.89-35.75-25.86-59.22-25.86h-62.4v262h48V166.35h14.42c9.06 0 17.25 3.73 23.08 9.73l166.66 179.06c14.64 15.89 35.75 25.86 59.22 25.86h62.4V119h-48z","fill":"#fff"}})])
          )
        }
      }
    